/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AbstractResourceService, JsonApiResource} from '@irian-ro/abstract-resource';
import {EnvironmentService} from "@irian-ro/util-environment";
import {LegalEntityTermsAndConditionsDto} from '@well/domain';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DelLegalEntityTermsAndConditionsResourceService extends AbstractResourceService<any, LegalEntityTermsAndConditionsDto, any, any> {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('delLegalEntityTermsAndConditionsUrl'),
      undefined,
      LegalEntityTermsAndConditionsDto
    );
  }

  getLatestCustomerValidDocumentForCurrent(customerUuid: string, documentLanguage: string): Observable<JsonApiResource<LegalEntityTermsAndConditionsDto, any>> {
    return <Observable<JsonApiResource<LegalEntityTermsAndConditionsDto, any>>>this.httpClient?.get(`${this.url}/latest/customer/${customerUuid}/${documentLanguage}/current`);
  }

  getLatestVendorValidDocumentForCurrent(vendorUuid: string, documentLanguage: string): Observable<JsonApiResource<LegalEntityTermsAndConditionsDto, any>> {
    return <Observable<JsonApiResource<LegalEntityTermsAndConditionsDto, any>>>this.httpClient?.get(`${this.url}/latest/vendor/${vendorUuid}/${documentLanguage}/current`);
  }

  getLatestValidDocumentForCustomer(customerUuid: string): Observable<JsonApiResource<LegalEntityTermsAndConditionsDto, any>> {
    return <Observable<JsonApiResource<LegalEntityTermsAndConditionsDto, any>>> this.httpClient?.get(`${this.url}/latest/for/customer/${customerUuid}`);
  }

}
